import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { Colors } from '../../styles/colors';

export const StyledContainer = styled(Box)({
    padding: '0px 24px',
});

export const StyledTitle = styled('h4')({
    fontWeight: 500,
    letterSpacing: '0.03em',
    color: Colors.PRIMARY_DARK,
    marginTop: '0px',
    marginBottom: '12px',
    fontSize: '18px',
});

export const StyledFiltersContainer = styled(Box)({
    display: 'flex',
    gap: '16px',
    marginBottom: '24px',
    alignItems: 'center',
    width: '100%',
});

export const StyledSearchField = styled(Box)({
    flex: 1,
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
    }
});

export const StyledDateField = styled(Box)({
    width: '260px',
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        color: Colors.NEUTRAL_GRAY,
        fontSize: '14px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
    }
});

export const StyledRiskSelect = styled(Box)({
    width: '260px',
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        color: Colors.NEUTRAL_GRAY,
        fontSize: '14px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: Colors.BORDER_GRAY,
        },
    }
});

export const StyledClearButton = styled(Button)({
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '14px',
    color: Colors.NEUTRAL_GRAY,
    whiteSpace: 'nowrap',
    padding: '6px 8px',
    minWidth: 0,
    '&:hover': {
        backgroundColor: 'transparent',
        color: Colors.NEUTRAL_GRAY,
        textDecoration: 'underline',
    },
});

export const StyledAddButton = styled(Button)({
    width: '180px',
    borderRadius: '24px',
    padding: '10px 20px',
    backgroundColor: Colors.PRIMARY_DARK,
    color: 'white',
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '14px',
    '&:hover': {
        backgroundColor: '#1A2B5C',
    },
});

export const StyledViewDetailsButton = styled(Button)({
    borderRadius: '20px',
    textTransform: 'none',
    fontSize: '12px',
    padding: '2px 16px',
    borderColor: Colors.BORDER_GRAY,
    color: Colors.PRIMARY_DARK,
    fontWeight: 400,
    '&:hover': {
        borderColor: Colors.BORDER_GRAY,
        color: Colors.PRIMARY_DARK,
    },
});

export const StyledBusinessCell = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
});

export const StyledBusinessAvatar = styled(Box)({
    width: 32,
    height: 32,
    backgroundColor: Colors.BRAND_BLUE,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const StyledRiskCell = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});
